import $ from "jquery";
import * as _ from "underscore";

import * as localAPI from "localAPI";
import * as modalDialog from "modalDialog";
import * as splitTest from "splitTest";
import AccountPanelView from "views/AccountPanelView";
import AccountPanelView2 from "views/AccountPanelView2";

export const show = async function (options) {
  const actionElement = $("<div/>");
  const messageElement = $("<div/>");
  const dialog = $("<div/>")
    .addClass("centralDialog")
    .append(messageElement)
    .append(actionElement);

  const prettier =
    window.location.pathname !== "/bookmarklet" &&
    !(await localAPI.isLocalMode());

  if (prettier) {
    dialog.addClass("greenBackground");
    dialog.append(
      $('<img src="/content/x-close.svg"/>')
        .addClass("closeDialogButton")
        .click(() => {
          modalDialog.cancel();
        })
    );
  }

  messageElement.html(
    prettier
      ? `
  <div class="speechBubbleContainer">
    <img src="/content/rabbitPoppingOut.svg" class="rabbitLogo" />
    <div class="speechBubble">
      <img src="/content/speechBubbleArrow.svg" class="speechBubbleArrow"></img>
      ${options.messageHtml}
    </div>
  </div>`
      : options.messageHtml
  );

  if (!/(readlang.com|localhost)\/bookmarklet/.test(window.location.href)) {
    // Show smart definition upsell everywhere except the bookmarklet, where it's not available.
    options.smartDefinitions = true;
  }

  if (prettier) {
    new AccountPanelView2(
      _.extend(
        {
          el: actionElement,
          plus: options.plus,
        },
        options
      )
    );
  } else {
    new AccountPanelView(
      _.extend(
        {
          el: actionElement,
        },
        options
      )
    );
  }

  modalDialog.show(dialog, {
    title: options.title,
    minHeight: 385,
    wide: true,
    cancelCallback: options.onCancel,
  });

  dialog.find(".continue").click(function () {
    modalDialog.cancel();
    if (options.onCancel) {
      options.onCancel();
    }
  });

  splitTest.trackEventWithProperties("showUpsellModal", {
    title: options.title,
  });
};
